import { useState } from 'react'
import { pushFormattedGtmEvent } from '@/logic/metrika/helpers'
import { isSomeEnum } from '@/typeguards/common'
import { EHarvestSaleGtmFieldName, HarvestSaleLotsFocusingGtmEventPayload, HarvestSaleLotsSubmittingGtmEventPayload } from './gtmConstants'

export const pushClickToSubmitFormGtmEvent = (eventStatus?: string) => {
  pushFormattedGtmEvent({
    ...HarvestSaleLotsSubmittingGtmEventPayload.submitOfferForm,
    eventStatus: eventStatus ?? HarvestSaleLotsSubmittingGtmEventPayload.submitOfferForm.eventStatus,
  })
}

const isHarvestSaleGtmFieldName = isSomeEnum(EHarvestSaleGtmFieldName)

export const useHarvestSaleGtmEventHandlers = () => {
  const [focusedFields, setFocusedFields] = useState<EHarvestSaleGtmFieldName[]>([])

  const pushFocusEventToGtm = <GFieldName = string>(fieldName: GFieldName, blockName?: string) => {
    if (isHarvestSaleGtmFieldName(fieldName) && !focusedFields.includes(fieldName)) {
      const payload = HarvestSaleLotsFocusingGtmEventPayload[fieldName]

      pushFormattedGtmEvent(blockName ? { ...payload, blockName } : payload)
      setFocusedFields(prev => [...prev, fieldName])
    }
  }

  return {
    pushFocusEventToGtm,
  }
}
